/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import i18next from 'i18next';
import Close from '@mui/icons-material/Close';
import { Link } from 'react-router-dom';

import { Typo } from 'uikit/content';
import { Button } from 'uikit/buttons';

import styles from '../styles/uikitChipsChip.module.scss';

const Chip = ({
  className = '',
  color = '',
  text = '',
  value = null,
  onClick = null,
  testId = '',
  to = '',
  isExternalLink = false,
}) => {
  let Element = 'div';
  const elementProps = {};

  if (to && isExternalLink) {
    Element = 'a';
    elementProps.href = to;
  } else if (to) {
    Element = Link;
    elementProps.to = to;
  }

  return (
    <Element
      className={classnames(styles.element, {
        [styles.isLink]: to,
      }, className)}
      data-testid={testId}
      {...elementProps}
    >
      {color && (
        <div className={styles.dot} style={{ backgroundColor: color }} />
      )}
      <div className={styles.text}>
        <Typo
          element="span"
          variant="s02"
          weight="medium"
        >
          {text}
        </Typo>
      </div>
      {onClick && (
        <Button
          ariaLabel={i18next.t('remove-item', { item: text })}
          className={styles.close}
          icon={<Close />}
          variant="ghost"
          size="xsmall"
          onClick={() => onClick(value)}
        />
      )}
    </Element>
  );
};

Chip.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  text: PropTypes.string,
  value: PropTypes.string,
  onClick: PropTypes.func,
  testId: PropTypes.string,
  to: PropTypes.string,
  isExternalLink: PropTypes.bool,
};

export default React.memo(Chip);
